import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { isNullish } from 'common/utils/utils';
import { getKeyBase } from 'common/utils/cookieHelper';

import { getMagicMovieUserId, setMagicMovieUserId } from 'store/magicMovie';
import { useAppDispatch, useAppSelector } from 'store/utils/hooks';

import MagicMovieDiagram from './Diagram';
import MagicMoviePopularMovies from './PopularMovies';
import MagicMovieRecommendedMovies from './RecommendedMovies';
import { movieGridView } from '../constants';

import './styles.css';

export const MagicMovieMovieGrid: React.FC = () => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(getMagicMovieUserId);
  const [currentView, setCurrentView] = useState(movieGridView.popularMovies);

  useEffect(() => {
    if (isNullish(userId)) {
      const keyBase = getKeyBase();
      const id = isNullish(keyBase) ? uuidv4() : keyBase;
      dispatch(setMagicMovieUserId({ userId: id }));
    }
  }, [dispatch, userId]);

  // Update current view whenever it is changed
  useEffect(() => {
    setCurrentView(currentView);
  }, [currentView]);

  const getComponent = () => {
    switch (currentView) {
      case movieGridView.diagram:
        return <MagicMovieDiagram onChangeView={setCurrentView} />;
      case movieGridView.recommendedMovies:
        return <MagicMovieRecommendedMovies onChangeView={setCurrentView} />;

      default:
        return <MagicMoviePopularMovies onChangeView={setCurrentView} />;
    }
  };

  return getComponent();
};
